module.exports = __webpack_public_path__ + "static/media/Cats eyes 05_SVENSKA-mixdown.ff65b738.mp3";